import * as paths from './paths'

export const MENU_COMERCIAL = [
  {
    title: 'Mercado de Motos',
    nodo: [
      { title: 'Total mercado', path: paths.TOTAL_MARKETS, download: false },
      {
        title: 'Mercado fáciles de manejar',
        path: paths.TOTAL_EASY_DRIVE,
        download: false,
      },
      {
        title: 'Mercado alta gama',
        path: paths.TOTAL_ALTA_GAMA,
        download: false,
      },
      { title: 'Mercado enduro', path: paths.TOTAL_ENDURO, download: false },
      { title: 'Mercado street', path: paths.TOTAL_STREET, download: false },
    ],
  },
  {
    title: 'Ventas y Market share',
    nodo: [
      {
        title: 'Total industria por compañía',
        path: paths.TOTAL_MARKET_SHARE,
        download: false,
      },
      {
        title: 'Fáciles de manejar',
        path: paths.TOTAL_MARKET_EASYTODRIVER,
        download: false,
      },
      {
        title: 'Alta gama por compañía',
        path: paths.TOTAL_MARKET_HIGH_RANGE,
        download: false,
      },
      {
        title: 'Enduro por compañía',
        path: paths.TOTAL_MARKET_ENDURO,
        download: false,
      },
      {
        title: 'Street por compañía',
        path: paths.TOTAL_MARKET_STREET,
        download: false,
      },
      {
        title: 'Resultados Auteco Mobility',
        path: paths.TOTAL_MARKET_TOTAL,
        download: false,
      },
    ],
  },
]

export const MOVILIDAD_ELECTRICA = [
  {
    title: 'Importaciones MEI',
    nodo: [
      {
        title: 'Importaciones movilidad eléctrica',
        path: paths.MEI_IMPORTS_INDIVIDUAL,
        download: false,
      },
    ],
  },
  {
    title: 'Mercado MEI',
    nodo: [
      {
        title: 'Mercado motos eléctricas',
        path: paths.MEI_MARKET,
        download: false,
      },
    ],
  },
  {
    title: 'Ventas MEI',
    nodo: [
      {
        title: 'Ventas total MEI',
        path: paths.MEI_MARKET_TOTAL_SALES,
        download: false,
      },
      {
        title: 'Ventas motos eléctricas',
        path: paths.MEI_MARKET_TOTAL_ELECTRIC,
        download: false,
      },
      {
        title: 'Ventas bicicletas eléctricas',
        path: paths.MEI_MARKET_ELECTRIC_BIKERS,
        download: false,
      },
      {
        title: 'Ventas patinetas eléctricas',
        path: paths.MEI_MARKET_SKATEBOARD,
        download: false,
      },
    ],
  },
]

export const REPUESTOS_ACCESORIOS = [
  {
    title: 'Mercado de repuestos',
    nodo: [
      {
        title: 'Importación total repuestos',
        path: paths.SPARE_PARTS_TOTAL,
        download: false,
      },
      {
        title: 'Importación originales',
        path: paths.SPARE_PARTS_ORIGINAL,
        download: false,
      },
      {
        title: 'Importación originales India',
        path: paths.SPARE_PARTS_ORIGINAL_INDIA,
        download: false,
      },
      {
        title: 'Importación especiales',
        path: paths.SPARE_PARTS_ORIGINAL_ESPECIAL,
        download: false,
      },
      {
        title: 'Importación llantas',
        path: paths.SPARE_PARTS_TYRES,
        download: false,
      },
      {
        title: 'Importación baterías',
        path: paths.SPARE_PARTS_BATERY,
        download: false,
      },
    ],
  },
  {
    title: 'Ventas y utilidades',
    nodo: [
      { title: 'Ventas y utilidades Rptos & Acc', download: true },
      { title: 'Ventas y utilidades total Rptos', download: true },
      { title: 'Ventas y utilidades originales', download: true },
      { title: 'Ventas y utilidades especiales', download: true },
      { title: 'Ventas y utilidades llantas', download: true },
      { title: 'Ventas y utilidades baterías', download: true },
      { title: 'Ventas y utilidades cadenas', download: true },
      { title: 'Ventas y utilidades lubricantes', download: true },
      { title: 'Ventas y utilidades accesorios', download: true },
    ],
  },
]

export const CARPA = [
  {
    title: 'Mercado de CARPA',
    nodo: [
      {
        title: 'Total mercado 4W+',
        path: paths.MARKET_TOTAL_4W,
        download: false,
      },
      {
        title: 'Mercado por Producto 4W+',
        path: paths.MARKET_TOTAL_PRODUCT,
        download: false,
      },
      { title: 'Mercado 3W', path: paths.MARKET_TOTAL_3W, download: false },
    ],
  },
]

export const OPERACIONES = [
  {
    title: 'Motos combustión',
    nodo: [
      { title: 'Productividad', download: true },
      { title: 'Paso directo', download: true },
      { title: 'Nivel de servicio - OTIF', download: true },
      { title: 'Costo variable producto (CVP)', download: true },
      { title: 'Inventario', download: true },
    ],
  },
  {
    title: 'Movilidad eléctrica',
    nodo: [
      { title: 'Productividad' },
      { title: 'Paso directo', download: true },
      { title: 'Nivel de servicio - OTIF', download: true },
      { title: 'Costo variable producto (CVP)', download: true },
      { title: 'Inventario', download: true },
    ],
  },
  {
    title: 'CARPA',
    nodo: [
      { title: 'Productividad', download: true },
      { title: 'Paso directo', download: true },
      { title: 'Nivel de servicio - OTIF', download: true },
      { title: 'Costo variable producto (CVP)', download: true },
      { title: 'Inventario', download: true },
    ],
  },
  {
    title: 'Accesorios',
    nodo: [
      { title: 'OTIF', download: true },
      { title: 'Inventario', download: true },
    ],
  },
  {
    title: 'Repuestos',
    nodo: [
      { title: 'Productividad', download: true },
      { title: 'Nivel de servicio - OTIF', download: true },
      { title: 'Gasto variable', download: true },
      { title: 'Inventario', download: true },
    ],
  },
]

export const FINANCIERA = [
  {
    title: 'Balance general',
    nodo: [{ title: 'Informe balance general', download: true }],
  },
  {
    title: 'Estado de resultados',
    nodo: [
      { title: 'P&G', download: true },
      { title: 'Margenes brutos', download: true },
      { title: 'Gastos fijos', download: true },
      { title: 'Gastos - Ingresos no operativos', download: true },
      { title: 'Coberturas', download: true },
      { title: 'Coorporativos', download: true },
      { title: 'Cartera', download: true },
      { title: 'Inventario', download: true },
    ],
  },
]

export const TALENTO = [
  {
    title: 'Eficiencia',
    nodo: [
      { title: 'Heat count', download: true },
      { title: 'Costo laboral', download: true },
      { title: 'Horas extras', download: true },
    ],
  },
  {
    title: 'Seguridad y salud',
    nodo: [
      { title: 'Ausentismo', download: true },
      { title: 'Accidentalidad', download: true },
    ],
  },
  {
    title: 'Desarrollo',
    nodo: [{ title: 'Rotación', download: true }],
  },
  {
    title: 'Fondo empleados',
    nodo: [{ title: 'Informe Fondo de empleados', download: true }],
  },
]

export const POSVENTA = [
  {
    title: 'Costo posventa',
    nodo: [{ title: 'Informe posventa', download: true }],
  },
  {
    title: 'PQR´s',
    nodo: [{ title: 'Informe PQR', download: true }],
  },
  {
    title: 'Porcentaje de fallas',
    nodo: [{ title: 'Informe porcentaje de fallas', download: true }],
  },
]

export const DESARROLLO = [
  {
    title: 'Proyectos combustión',
    nodo: [{ title: 'Informe combustión', download: true }],
  },
  {
    title: 'Proyectos ME',
    nodo: [{ title: 'Informe Proyectos ME', download: true }],
  },
  {
    title: 'Proyectos CARPA',
    nodo: [{ title: 'Informe CARPA', download: true }],
  },
  {
    title: 'Proyectos Everest',
    nodo: [{ title: 'Informe Everest', download: true }],
  },
]

export const CUSTOMERS = [
  {
    title: 'e-Commerce',
    nodo: [{ title: 'Informe e-Commerce', download: true }],
  },
  {
    title: 'Mkting Relacional',
    nodo: [
      { title: 'Interacciones por canal', download: true },
      { title: 'Servicios', download: true },
      { title: 'Tipificación', download: true },
      { title: 'Satisfacción', download: true },
    ],
  },
]
